import { API } from '@aws-amplify/api'

import { WOMA_API_GATEWAY_NAME } from '../../constants/aws'
import { addSearchData, updateSearchDataFetchInProgress, updateSearchData } from '../actions'

interface SearchRequest {
  user_id: string | null
  trf_id: string | null
  user_role: string | null
}

interface FilterRequest {
  user_id: string | null
  caseView: string | null
  filterField: string | null
  filterValue: any | Record<string, unknown> | null //chaanged to Record for linting
  startDate: string | null
  endDate: string | null
  sortOrder: string | null
  pageIndex: number | 0
  pageSize: number | 10
}

export const getSearchByTRFData =
  ({ user_id, trf_id, user_role }: SearchRequest) =>
  async (dispatch) => {
    let action = ''
    try {
      let apiName = '/case-management/case-search'
      if (user_role === 'NL_Pathologist') apiName = '/case-management/pathologist-case-search'
      const options = {
        headers: {},
        response: false,
        queryStringParameters: {
          trfid: trf_id,
        },
      }
      dispatch(updateSearchDataFetchInProgress(true, trf_id))
      const result = await API.get(WOMA_API_GATEWAY_NAME, `${apiName}/${user_id}`, options)

      if (result?.data) {
        result?.data.map((value, i) => {
          value.rowId = i + 1
          return value
        })
        action = 'SEARCH_DATA_SUCCESS'
        await dispatch(addSearchData({ payload: result, userId: user_id, trfId: trf_id }))
      }
    } catch (err) {
      action = 'SEARCH_DATA_ERROR'
      console.log('getSearchByTRFData Error', err)
    } finally {
      dispatch(updateSearchData({ action: action }))
      dispatch(updateSearchDataFetchInProgress(false, trf_id))
    }
  }
